<template>
  <section class="nav font-Am">
    <div class="content">
      <div class="logoBox">
        <a :href="menu[0].path" class="logoLink">
          <img src="../../assets/img/nav/logo.png" alt="logo" class="logo">
        </a>
      </div>
      <ul ref="navList" class="navList" :class="{hide: !btnState}"  @touchmove.prevent  @wheel="handleWheel">
        <li class="linkBox" v-for="(m, key) in menu" :key="key" :ref="'nav' + key">
          <a class="link ffMedium" :href="m.path" v-if="m.target === 'local'">{{ m.name }}</a>
          <router-link class="link ffMedium" @click.native="goRoute" :to="m.path" v-else-if="m.target !== '_blank'">{{ m.name }}</router-link>
          <a class="link ffMedium" :href="m.path" target="_blank" v-else>{{ m.name }}</a>
        </li>
      </ul>
      <div class="btnBox" @click="showNav">
        <div class="btn" ref="btnLineBox">
          <div class="btnLine line1" ref="btnLine1"></div>
          <div class="btnLine line2" ref="btnLine2"></div>
          <div class="btnLine line3" ref="btnLine3"></div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    data () {
      return {
        btnState: false,
        menu: [
          { "name": "Home", "path": "https://pundix.com/", "target": "local"},
          { "name": "XPOS", "path": "https://pundix.com/product", "target": "local"},
          { "name": "XWallet", "path": "/"},
          { "name": "PUNDIX", "path": "https://pundix.com/pundix", "target": "local"},
          { "name": "Open Platform", "path": "https://developer.pundix.com", "target": "_blank"},
          { "name": "Function X", "path": "https://functionx.io/", "target": "local"},
          { "name": "Blog", "path": "https://blog.pundix.com", "target": "_blank" },
          { "name": "Press", "path": "https://pundix.com/press", "target": "local"},
          { "name": "FAQ", "path": "https://pundix.com/faq", "target": "local"},
          { "name": "About Us", "path": "https://pundix.com/about", "target": "local"},
          { "name": "Partnerships", "path": "https://pundix.com/partnerships", "target": "local"},
          { "name": "Store", "path": "https://shop.pundix.com", "target": "_blank" },
          { "name": "Join Us", "path": "https://pundix.com/join", "target": "local"}
        ]
      }
    },
    methods: {
      goRoute () {
        if (window.document.documentElement.clientWidth <= 768) {
          this.showNav()
        }
      },
      path (url) {
        return (this.$i18n.locale === 'en' ? url : '/' + this.$i18n.locale + url)
      },
      // 显示导航
      showNav () {
        if (!this.btnState) {
          // 显示导航
          this.btnState = !this.btnState
          const tl = new this.$gsap.TimelineMax()
          const anime1 = this.$gsap.TweenMax.fromTo(this.$refs.navList, 0.2, {
            opacity: 0
          }, {
            opacity: 1
          })
          tl.add(anime1)
          for (const key in this.menu) {
            const anime = this.$gsap.TweenMax.fromTo(this.$refs['nav' + key], 0.2, {
              opacity: 0,
              y: 30
            }, {
              opacity: 1,
              y: 0
            })
            tl.add(anime, '-=0.18')
          }
          tl.play()
          // 展开按钮
          const btnTl = new this.$gsap.TimelineMax()
          const btnAnime1 = this.$gsap.TweenMax.fromTo(this.$refs.btnLineBox, 0.4, {
            rotation: 0
          }, {
            rotation: 180,
            x: -2
          })
          const btnAnime2 = this.$gsap.TweenMax.to(this.$refs.btnLine1, 0.4, {
            rotation: 45
          })
          const btnAnime3 = this.$gsap.TweenMax.to(this.$refs.btnLine2, 0.4, {
            scaleX: 0
          })
          const btnAnime4 = this.$gsap.TweenMax.to(this.$refs.btnLine3, 0.4, {
            rotation: -45
          })
          btnTl.add(btnAnime1)
          btnTl.add(btnAnime2, '-=0.4')
          btnTl.add(btnAnime3, '-=0.4')
          btnTl.add(btnAnime4, '-=0.4')
          btnTl.play()
        } else {
          // 隐藏导航
          this.$gsap.TweenMax.fromTo(this.$refs.navList, 0.3, {
            opacity: 1
          }, {
            opacity: 0,
            onComplete: () => {
              this.btnState = !this.btnState
              this.$refs.navList.style.opacity = 1
            }
          })
          // 收起按钮
          const btnTl = new this.$gsap.TimelineMax()
          const btnAnime1 = this.$gsap.TweenMax.to(this.$refs.btnLineBox, 0.4, {
            rotation: 360,
            x: 0
          })
          const btnAnime2 = this.$gsap.TweenMax.to(this.$refs.btnLine1, 0.4, {
            rotation: 0
          })
          const btnAnime3 = this.$gsap.TweenMax.to(this.$refs.btnLine2, 0.4, {
            scaleX: 1
          })
          const btnAnime4 = this.$gsap.TweenMax.to(this.$refs.btnLine3, 0.4, {
            rotation: 0
          })
          btnTl.add(btnAnime1)
          btnTl.add(btnAnime2, '-=0.4')
          btnTl.add(btnAnime3, '-=0.4')
          btnTl.add(btnAnime4, '-=0.4')
          btnTl.play()
        }
      },
      // 禁用滚动事件
      handleWheel (e) {
        e.preventDefault()
      }
    }
  }
</script>

<style scoped>
  .nav{
    width: 100%;
    background-color: rgba(27,27,31, 0.98);
  }
  .content{
    width: 100%;
    position: relative;
    box-sizing: border-box;
    padding-left: 100px;
    padding-right: 100px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .logoBox{
    width: 80px;
    flex-shrink: 0;
  }
  .logoLink{
    width: 100%;
    display: block;
  }
  .logo{
    width: 100%;
    display: block;
  }
  .navList{
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .linkBox{
  }
  .linkBox+.linkBox{
    margin-left: 40px;
  }
  .link{
    display: block;
    padding-top: 14px;
    padding-bottom: 10px;
    border-bottom: 2px solid transparent;
    font-size: 14px;
    color: rgba(255,255,255,0.50);
    transition: color 0.3s;
  }
  .link:hover{
    color: #FFBE12;
  }
  .link.router-link-active{
    color: #FFBE12;
    border-bottom-color: #FFBE12;
  }
  .btnBox{
    display: none;
    height: 100%;
    position: absolute;
    right: 5px;
    width: 45px;
    cursor: pointer;
  }
  .btn{
    display: none;
    width: 14px;
    height: 12px;
    position: absolute;
    right: 14px;
    bottom: 12px;
    transform-origin: center;
  }
  .btnLine{
    width: 100%;
    height: 2px;
    background-color: #FFF;
    position: absolute;
  }
  .line1{
    top: 0;
    transform-origin: left center;
  }
  .line2{
    top: 5px;
  }
  .line3{
    top: 10px;
    transform-origin: left center;
  }
  @media screen and (max-width: 1500px) and (min-width: 1101px){
    .content{
      padding-left: 40px;
      padding-right: 40px;
    }
    .linkBox+.linkBox{
      margin-left: 20px;
    }
  }
  @media screen and (max-width: 1100px) and (min-width: 769px){
    .content{
      padding-left: 20px;
      padding-right: 20px;
    }
    .linkBox+.linkBox{
      margin-left: 14px;
    }
  }
  @media screen and (max-width: 980px){
    .content{
      height: 44px;
      padding-left: 20px;
      padding-right: 20px;
      justify-content: center;
      align-items: center;
    }
    .logoBox{
      width: 46px;
    }
    .btnBox{
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .btn{
      display: block;
      bottom: auto;
    }
    .navList{
      position: fixed;
      top: 44px;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(27,27,31,0.94);
      z-index: 1000;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      box-sizing: border-box;
      padding-top: 15px;
      padding-bottom: 0;
    }
    .navList.hide{
      display: none;
    }
    .linkBox{
      width: 100%;
    }
    .linkBox+.linkBox{
      margin-left: 0px;
    }
    .link{
      width: 100%;
      box-sizing: border-box;
      text-align: center;
      border-bottom: none;
      padding: 15px;
    }
  }
  @media screen and (max-width: 370px){
    .link{
      padding: 8px;
    }
  }

</style>